function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { Entity } from "./Entity";
import * as $array from "./Array";
import * as $object from "./Object";
import en from "../../../locales/en";
;
/**
 * Add localization functionality.
 */
export var Language = /*#__PURE__*/function (_Entity) {
  _inherits(Language, _Entity);
  var _super = _createSuper(Language);
  function Language() {
    _classCallCheck(this, Language);
    return _super.apply(this, arguments);
  }
  _createClass(Language, [{
    key: "_setDefaults",
    value: function _setDefaults() {
      this.setPrivate("defaultLocale", en);
      _get(_getPrototypeOf(Language.prototype), "_setDefaults", this).call(this);
    }
    /**
     * Returns a prompt translation.
     *
     * @param   prompt   Prompt to translate
     * @param   locale   Target locale
     * @param   ...rest  Parameters
     * @return           Translation
     */
  }, {
    key: "translate",
    value: function translate(prompt, locale) {
      // Get langauge
      if (!locale) {
        locale = this._root.locale || this.getPrivate("defaultLocale");
      }
      // Init translation
      var translation = prompt;
      var value = locale[prompt];
      // Try to look for the translation
      for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        rest[_key - 2] = arguments[_key];
      }
      if (value === null) {
        translation = "";
      } else if (value != null) {
        // It might be an empty string
        if (value) {
          translation = value;
        }
      } else if (locale !== this.getPrivate("defaultLocale")) {
        // Try to look in default language
        return this.translate.apply(this, [prompt, this.getPrivate("defaultLocale")].concat(rest));
      }
      // Replace %1, %2, etc params
      if (rest.length) {
        for (var len = rest.length, i = 0; i < len; ++i) {
          translation = translation.split("%" + (i + 1)).join(rest[i]);
        }
      }
      // Return the translation
      return translation;
    }
    /**
     * Returns a prompt translation, including custom prompts.
     *
     * @param   prompt   Prompt to translate
     * @param   locale   Target locale
     * @param   ...rest  Parameters
     * @return           Translation
     */
  }, {
    key: "translateAny",
    value: function translateAny(prompt, locale) {
      for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        rest[_key2 - 2] = arguments[_key2];
      }
      return this.translate.apply(this, [prompt, locale].concat(rest));
    }
    /**
     * Add a custom prompt to locale.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/locales/creating-translations/#Extending_locale_with_custom_prompts}
     * @param  prompt       Source prompt
     * @param  translation  Tanslation
     * @param  locale       Target locale
     */
  }, {
    key: "setTranslationAny",
    value: function setTranslationAny(prompt, translation, locale) {
      var localeTarget = locale || this._root.locale;
      localeTarget[prompt] = translation;
    }
    /**
     * Add a batch of custom prompts.
     *
     * @since 5.3.3
     * @see {@link https://www.amcharts.com/docs/v5/concepts/locales/creating-translations/#Extending_locale_with_custom_prompts}
     * @param  translations  Translations
     * @param  locale        Target locale
     */
  }, {
    key: "setTranslationsAny",
    value: function setTranslationsAny(translations, locale) {
      var _this = this;
      $object.each(translations, function (key, val) {
        _this.setTranslationAny(key, val, locale);
      });
    }
  }, {
    key: "translateEmpty",
    value: function translateEmpty(prompt, locale) {
      for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        rest[_key3 - 2] = arguments[_key3];
      }
      var translation = this.translate.apply(this, [prompt, locale].concat(rest));
      return translation == prompt ? "" : translation;
    }
  }, {
    key: "translateFunc",
    value: function translateFunc(prompt, locale) {
      if (this._root.locale[prompt]) {
        return this._root.locale[prompt];
      }
      // Try to look in default language
      if (locale !== this.getPrivate("defaultLocale")) {
        return this.translateFunc(prompt, this.getPrivate("defaultLocale"));
      }
      // Fail - return empty function
      return function () {
        return "";
      };
    }
    /**
     * Translates a btach of prompts.
     *
     * @param  list    Array of prompts to translate
     * @param  locale  Target locale
     * @return         Array of translations
     */
  }, {
    key: "translateAll",
    value: function translateAll(list, locale) {
      var _this2 = this;
      // Translate all items in the list
      if (!this.isDefault()) {
        return $array.map(list, function (x) {
          return _this2.translate(x, locale);
        });
      } else {
        return list;
      }
    }
    /**
     * Returns `true` if the currently selected locale is a default locale.
     *
     * @return `true` if locale is default; `false` if it is not.
     */
  }, {
    key: "isDefault",
    value: function isDefault() {
      return this.getPrivate("defaultLocale") === this._root.locale;
    }
  }]);
  return Language;
}(Entity);